export const Institution = {
  CHILD_CARE_CENTER: '어린이집',
  KINDERGARTEN: '유치원',
  ELEMENTARY_SCHOOL: '초등학교',
  ETC: '기타',
} as const;
